import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { locale as italian } from "../../../../../i18n/it";
import { ContractService } from "../../../../../auth/service/contract.service";

@Component({
  selector: "app-contract-list-for-type",
  templateUrl: "./contract-list-for-type.component.html",
  styleUrls: ["./contract-list-for-type.component.scss"],
})
export class ContractListForTypeComponent implements OnInit {
  public activeTab: string = "firstSection";
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public indeterminateList: any[] = [];
  public filteredIndeterminateList: any[] = [];
  public apprenticeshipList: any[] = [];
  public filteredApprenticeshipList: any[] = [];
  public ral: string = null;
  public bonus: string = "0,00";
  public calculatedContract: any = null;
  public selectedType: any = "indeterminate";

  constructor(
    public _changeDetectorRef: ChangeDetectorRef,
    public _utilService: UtilsService,
    public _contractService: ContractService,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.SIMULATION_CONTRACT_COSTS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.SIMULATION_CONTRACT_COSTS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    const contractList: any = await this._contractService.getCosts();
    if (!!contractList && contractList.length > 0) {
      this.indeterminateList = contractList.filter((item: any) => !item.is_apprendistato);
      this.apprenticeshipList = contractList.filter((item: any) => item.is_apprendistato);
      this.apprenticeshipList = this.apprenticeshipList.sort((a: any, b: any) => (b.level > a.level ? 1 : -1));

      this.filteredIndeterminateList = JSON.parse(JSON.stringify(this.indeterminateList));
      this.filteredApprenticeshipList = JSON.parse(JSON.stringify(this.apprenticeshipList)).sort((a: any, b: any) => {
        a = Number(a.salary_yearly_gross);
        b = Number(b.salary_yearly_gross);
        return a > b ? 1 : a < b ? -1 : 0;
      });
    }
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  formatMoney(field: string) {
    if (field === "ral") {
      this.ral = this._utilService.addDotsToNumber(this.ral);
    } else {
      this.bonus = this._utilService.addDotsToNumber(this.bonus);
    }
  }

  calculateCost() {
    this.calculatedContract = {};
    const ral: any = this._utilService.removeDotsFromNumber(this.ral);
    const max: any = this.selectedType === "indeterminate" ? this.indeterminateList[this.indeterminateList.length - 1] : this.filteredApprenticeshipList[this.filteredApprenticeshipList.length - 1];
    const min: any = this.selectedType === "indeterminate" ? this.indeterminateList[0] : this.apprenticeshipList[0];
    let contractsList: any[] = this.selectedType === "indeterminate" ? JSON.parse(JSON.stringify(this.indeterminateList)) : JSON.parse(JSON.stringify(this.filteredApprenticeshipList));
    let contract: any;
    if (Number(max.salary_yearly_gross) <= ral) {
      this.calculatedContract = {
        level: max.level,
        salary_yearly_gross: this._utilService.addDotsToNumber(ral),
        total_yearly: this._utilService.addDotsToNumber(max.total_yearly),
        total_month: this._utilService.addDotsToNumber(max.total_month),
        net_monthly_12: this._utilService.addDotsToNumber(max.net_monthly_12),
        net_monthly_13: this._utilService.addDotsToNumber(max.net_monthly_13),
        total_daily: this._utilService.addDotsToNumber(max.total_daily),
      };
    } else if (Number(min.salary_yearly_gross) >= ral) {
      this.calculatedContract = {
        level: min.level,
        salary_yearly_gross: this._utilService.addDotsToNumber(min.salary_yearly_gross),
        total_yearly: this._utilService.addDotsToNumber(min.total_yearly),
        total_month: this._utilService.addDotsToNumber(min.total_month),
        net_monthly_12: this._utilService.addDotsToNumber(min.net_monthly_12),
        net_monthly_13: this._utilService.addDotsToNumber(min.net_monthly_13),
        total_daily: this._utilService.addDotsToNumber(min.total_daily),
      };
    } else {
      //Cerco quello che piú si avvicina tra tutti gli elementi tramite la differenza
      for (let item of contractsList) {
        item.difference = Math.round(Math.abs(Number(item.salary_yearly_gross) - ral));
      }
      const sortedContracts: any[] = contractsList.sort((a, b) => a.difference - b.difference);
      contract = sortedContracts[0];
      /*x = (ral_inserita / ral_lvl_match) / campo_da_calcolare*/
      this.calculatedContract = {
        level: contract.level,
        salary_yearly_gross: this._utilService.addDotsToNumber(ral),
        total_yearly: this._utilService.addDotsToNumber((ral / contract.salary_yearly_gross) * contract.total_yearly),
        total_month: this._utilService.addDotsToNumber((ral / contract.salary_yearly_gross) * contract.total_month),
        net_monthly_12: this._utilService.addDotsToNumber((ral / contract.salary_yearly_gross) * contract.net_monthly_12),
        net_monthly_13: this._utilService.addDotsToNumber((ral / contract.salary_yearly_gross) * contract.net_monthly_13),
        total_daily: this._utilService.addDotsToNumber((ral / contract.salary_yearly_gross) * contract.total_daily),
      };
    }
    if (!!this.bonus && this.bonus != "0.00" && this.bonus != "0.0" && this.bonus != "0" && this.bonus != "0,00") {
      if (!!this.calculatedContract) {
        this.calculatedContract.total_yearly = this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.calculatedContract.total_yearly) + this._utilService.removeDotsFromNumber(this.bonus) * 12);
        this.calculatedContract.total_month = this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.calculatedContract.total_month) + this._utilService.removeDotsFromNumber(this.bonus));
        this.calculatedContract.net_monthly_12 = this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.calculatedContract.net_monthly_12) + this._utilService.removeDotsFromNumber(this.bonus));
        this.calculatedContract.net_monthly_13 = this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.calculatedContract.net_monthly_13) + this._utilService.removeDotsFromNumber(this.bonus));
        this.calculatedContract.total_daily = this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.calculatedContract.total_daily) + this._utilService.removeDotsFromNumber(this.bonus) / 20);
      }
    }
  }

  calculateBonus(row: any, type: string) {
    if (row.bonus !== "0,00" && row.bonus != "0" && row.bonus != "0.00") {
      const findContract = type === "indeterminate" ? this.indeterminateList.find((el) => el.id === row.id) : this.apprenticeshipList.find((el) => el.id === row.id);
      if (!!findContract) {
        row.total_yearly = Number(findContract.total_yearly) + this._utilService.removeDotsFromNumber(row.bonus) * 12;
        row.total_month = Number(findContract.total_month) + this._utilService.removeDotsFromNumber(row.bonus);
        row.net_monthly_12 = Number(findContract.net_monthly_12) + this._utilService.removeDotsFromNumber(row.bonus);
        row.net_monthly_13 = Number(findContract.net_monthly_13) + this._utilService.removeDotsFromNumber(row.bonus);
        row.total_daily = Number(findContract.total_daily) + this._utilService.removeDotsFromNumber(row.bonus) / 20;
      }
    }
    row.edit_line = false;
  }

  resetBonus(row: any, type: string) {
    const findContract = type === "indeterminate" ? this.indeterminateList.find((el) => el.id === row.id) : this.apprenticeshipList.find((el) => el.id === row.id);
    if (!!findContract) {
      row.bonus = findContract.bonus;
      row.net_monthly_12 = findContract.net_monthly_12;
      row.net_monthly_13 = findContract.net_monthly_13;
      row.total_month = findContract.total_month;
      row.total_daily = findContract.total_daily;
    }
    row.edit_line = false;
  }

  formatBonusValue(row: any) {
    row.bonus = this._utilService.addDotsToNumber(row.bonus);
  }
}
